import { render, staticRenderFns } from "./order-form-property-front.vue?vue&type=template&id=165153fd&scoped=true"
import script from "./order-form-property-front.vue?vue&type=script&lang=js"
export * from "./order-form-property-front.vue?vue&type=script&lang=js"
import style0 from "./order-form-property-front.vue?vue&type=style&index=0&id=165153fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165153fd",
  null
  
)

export default component.exports